import { useState, useEffect } from "react";
import { fetchHealth } from "../api/health";
import type { HealthResponse } from "../types";

export function useHealth(refreshInterval = 30000) {
  const [health, setHealth] = useState<HealthResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = () => {
      fetchHealth()
        .then(setHealth)
        .catch((e) => setError(e instanceof Error ? e.message : "Fehler"))
        .finally(() => setLoading(false));
    };

    load();
    const interval = setInterval(load, refreshInterval);
    return () => clearInterval(interval);
  }, [refreshInterval]);

  return { health, loading, error };
}
